import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import AboutUsPage from './pages/AboutUsPage';
import OurServicesPage from './pages/OurServicesPage';
import DriveWithUsPage from './pages/DriveWithUsPage';
import BlogPage from './pages/BlogPage';
import UrbanPollutionPage from './pages/blog/UrbanPollutionPage';
import ModiFuelPage from './pages/blog/ModiFuelPage';
import SafetyPage from './pages/SafetyPage';
import ContactUsPage from './pages/ContactUsPage';
import AppOpenPage from './pages/AppOpenPage';
import AppInstallPage from './pages/AppInstallPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import AdvertisementPage from './pages/AdvertisementPage';

// ScrollToTop component to reset scroll on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<AboutUsPage />} />
          <Route path="/services" element={<OurServicesPage />} />
          <Route path="/drive-with-us" element={<DriveWithUsPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/urban-pollution" element={<UrbanPollutionPage />} />
          <Route path="/blog/pm-modi-fuel-conservation-india-electric-vehicles" element={<ModiFuelPage />} />
          <Route path="/safety" element={<SafetyPage />} />
          <Route path="/advertise" element={<AdvertisementPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/appinstall" element={<AppInstallPage />} />
          <Route path="/appopen" element={<AppOpenPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
